import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { ValentineState } from "../types";

const selectValentine = (state: RootState): ValentineState => state?.valentine;

export default createDraftSafeSelector(
  selectValentine,
  (valentine: ValentineState): boolean => valentine.isOpenShareModal
);
